/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type WebFilterTransport = typeof WebFilterTransport[keyof typeof WebFilterTransport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WebFilterTransport = {
  Air: 'Air',
  Bus: 'Bus',
} as const;
